// extracted by mini-css-extract-plugin
export default {"Spinner":"ButtonSpinner_Spinner__dGDYi","Waiting":"ButtonSpinner_Waiting__fuXg9"};